import DeleteModal from "../components/DeleteModal";
import { deleteArtist } from "../clients/art";

function DeleteArtistModal(props) {
  return (
    <DeleteModal
      request={deleteArtist}
      id={props.id}
      onClose={props.onClose}
      onDelete={props.onDelete}
      toastMessage="The artist was deleted"
      title="Delete artist?"
      confirmText={props.name}
      message={
        <p className="m-0">
          Do you want to delete&nbsp;
          <span className="text-muted">{props.name}</span>
          &nbsp;permanently?
        </p>
      }
    />
  );
}

export default DeleteArtistModal;
